module.exports = __webpack_public_path__ + "media/icons/marki-modele-da57b44b.png";